import { render, staticRenderFns } from "./TextChipButton.vue?vue&type=template&id=19ef4bf1"
import script from "./TextChipButton.vue?vue&type=script&lang=js"
export * from "./TextChipButton.vue?vue&type=script&lang=js"
import style0 from "./TextChipButton.vue?vue&type=style&index=0&id=19ef4bf1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports